export enum AutoInventoryStatus {
  Activated = 'Activated',
  Deactivated = 'Deactivated',
}
